import YMALCarousel from './YMALCarousel';

export default YMALCarousel;
